/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IObrienHomeAboutData } from './obrien-home-about.data';
import { IObrienHomeAboutProps } from './obrien-home-about.props.autogenerated';

export interface IObrienHomeAboutViewProps extends IObrienHomeAboutProps<IObrienHomeAboutData> {
    obAboutBackground: React.ReactNode;
    obAboutLogo: string;
    obAboutContent: string;
    obAboutButtonLink: string;
    obAboutButtonText: string;
    obCatalogTitle: string;
    obCatalogImage: React.ReactNode;
    obCatalogButtonText: string;
    obCatalogButtonLink: string;
    obTeamTitle: string;
    obIndTeamImage1: React.ReactNode;
    obIndTeamTitle1: string;
    obIndTeamImage2: React.ReactNode;
    obIndTeamTitle2: string;
    obTeamButtonText: string;
    obTeamButtonLink: string;
    
}

/**
 *
 * ObrienHomeAbout component
 * @extends {React.PureComponent<IObrienHomeAboutProps<IObrienHomeAboutData>>}
 */
class ObrienHomeAbout extends React.PureComponent<IObrienHomeAboutProps<IObrienHomeAboutData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const { 
            obAboutBackground,
            obCatalogImage,
            obIndTeamImage1,
            obIndTeamImage2
        } = this.props.config;

        //const AboutBackground = config.obAboutBackground ? config.obAboutBackground.src : '';
        const AboutLogo = config.obAboutLogo ? config.obAboutLogo.src : '';
        const AboutContent = config.obAboutContent ? config.obAboutContent : 'No Content';
        const AboutButtonLink = config.obAboutButtonLink ? config.obAboutButtonLink : 'No Link';
        const AboutButtonText = config.obAboutButtonText ? config.obAboutButtonText : 'No Text';
        const CatalogTitle = config.obCatalogTitle ? config.obCatalogTitle : 'No Header Name Provided';
        //const CatalogImage = config.obCatalogImage ? config.obCatalogImage.src : '';
        const CatalogButtonLink = config.obCatalogButtonLink ? config.obCatalogButtonLink : 'No Link';
        const CatalogButtonText = config.obCatalogButtonText ? config.obCatalogButtonText : 'No Text';
        const TeamTitle = config.obTeamTitle ? config.obTeamTitle : 'No Text';
        //const IndTeamImage1 = config.obIndTeamImage1 ? config.obIndTeamImage1.src : '';
        const IndTeamTitle1 = config.obIndTeamTitle1 ? config.obIndTeamTitle1 : 'No Text';
        //const IndTeamImage2 = config.obIndTeamImage2 ? config.obIndTeamImage2.src : '';
        const IndTeamTitle2 = config.obIndTeamTitle2 ? config.obIndTeamTitle2 : 'No Text';
        const TeamButtonText = config.obTeamButtonText ? config.obTeamButtonText : 'No Text';
        const TeamButtonLink = config.obTeamButtonLink ? config.obTeamButtonLink : 'No Text';


        // About Background
        const aboutImageProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obAboutBackground && obAboutBackground.imageSettings,
        };
        const aboutImage = obAboutBackground && (
            <Msdyn365.Image {...obAboutBackground} {...aboutImageProps} editProps ={{key:this.props.config.obAboutBackground || {}, requestContext: this.props.context.request}}/>
        );

        // Catalog Image
        const catalogImageProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obCatalogImage && obCatalogImage.imageSettings,
        };
        const catalogImage = obCatalogImage && (
            <Msdyn365.Image {...obCatalogImage} {...catalogImageProps} editProps ={{key:this.props.config.obCatalogImage || {}, requestContext: this.props.context.request}}/>
        );

        // Team 1 Image
        const team1ImageProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obIndTeamImage1 && obIndTeamImage1.imageSettings,
        };
        const team1Image = obIndTeamImage1 && (
            <Msdyn365.Image {...obIndTeamImage1} {...team1ImageProps} editProps ={{key:this.props.config.obIndTeamImage1 || {}, requestContext: this.props.context.request}}/>
        );

        // Team 2 Image
        const team2ImageProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: obIndTeamImage2 && obIndTeamImage2.imageSettings,
        };
        const team2Image = obIndTeamImage2 && (
            <Msdyn365.Image {...obIndTeamImage2} {...team2ImageProps} editProps ={{key:this.props.config.obIndTeamImage2 || {}, requestContext: this.props.context.request}}/>
        );

        
        const ObrienHomeAboutProps = {
            ...this.props,
            obAboutBackground: aboutImage,
            obAboutLogo: AboutLogo,
            obAboutContent: AboutContent,
            obAboutButtonLink: AboutButtonLink,
            obAboutButtonText: AboutButtonText,
            obCatalogTitle: CatalogTitle,
            obCatalogImage: catalogImage,
            obCatalogButtonLink: CatalogButtonLink,
            obCatalogButtonText: CatalogButtonText,
            obTeamTitle: TeamTitle,
            obIndTeamImage1: team1Image,
            obIndTeamTitle1: IndTeamTitle1,
            obIndTeamImage2: team2Image,
            obIndTeamTitle2: IndTeamTitle2,
            obTeamButtonText: TeamButtonText,
            obTeamButtonLink: TeamButtonLink

        };

        return this.props.renderView(ObrienHomeAboutProps);
    }
}

export default ObrienHomeAbout;
